import { apiSlice } from '../../api/apiSlice';

export const methodizeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMethodizeUrl: builder.mutation({
      query: () => ({
        url: 'Methodize/Url',
        method: 'GET',
        credentials: 'include'
      })
    }),
  })
});

export const {
  useGetMethodizeUrlMutation
} = methodizeApi;